<template>
  <div id="box">
    <div :class="isActive ? 'header__layout heads_layout' : 'header__layout'">
      <div @click="logoClick" class="tologo"></div>
      <!-- <div class="logo" @click="logoClick"></div>
      <div class="backlogo" @click="logoClick"></div> -->
      <img class="logo" src="../../../static/common/logo.png" @click="logoClick">
      <div class="header-menu">
        <el-menu :default-active="activeIndex" menu-trigger="click" style="height: 80px; border:0;" mode="horizontal"
          @select="handleSelect">
          <el-menu-item v-for="(item, index) in menuList" :key="index" :index="index + ''" class="header-menu-item">
            <span>{{ item.name }}</span>
            <div v-if="activeIndex == index" class="active-line"></div>
            <div v-if="item.children && item.children.length > 0" style="z-index:999" class="child-menu">
              <p v-for="(item, index) in item.children" :key="'tab' + index" @click.stop="handleMenu(item)">{{ item.name
              }}</p>
            </div>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="flexs">
        <div :class="isActive ? 'open opens' : 'open'" @click="btnClikc">
          开立账户
        </div>
        <div :class="isActive ? 'deal deals' : 'deal'" @click="handleTrade">
          立即交易
        </div>
      </div>

      <HumanService />
    </div>
    <div :class="isActive ? 'wapTopBox wapTopBoxs' : 'wapTopBox'">
      <img class="img" v-if="!isActive" src="../../../static/common/logo.png" @click="logoClickWap" alt="">
      <!-- <div class="img" @click="logoClickWap" alt=""></div> -->
      <img class="imgs" v-if="!isActive" src="../../../static/common/menu.png" @click="controlMenuShow" alt="">
      <!-- <img class="menuImgs" src="/subject/springCustom/wapmenu.png" @click="controlMenuShow" alt=""> -->
      <div class="tologo" @click="logoClickWap"></div>
    </div>
    <div class="wapBox">
      <van-popup id="drawer" v-model="show" closeable close-icon-position="top-right" position="right"
        @opened="openPopup" @click-close-icon="closerPopup" :style="{ height: '100%', width: '100%' }">
        <div class="menuBox">
          <div class="logoBox">
            <img v-if="!navBarFixed" @click="logoClickWap" id="header-img" src="../../../static/common/logo.png">
            <img v-if="navBarFixed" id="header-img" src="../../../static/common/logowhite.png" alt="">
          </div>
          <div class="header-menu">

            <el-col>
              <el-menu :default-active="controlMenuClass" :default-openeds="defaultWapMenu"
                class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#ffffff"
                active-text-color="#d52226" unique-opened ref="kzMenu" @select="handleSelects">

                <!-- <el-menu-item index="1">
                  <span slot="title">关于我们</span>
                </el-menu-item> -->

                <el-submenu index="1">
                  <template slot="title">
                    <span @click="menuAboutus(1)">关于我们</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item index="1-2">公司简介</el-menu-item>
                  </el-menu-item-group>
                  <!-- <el-menu-item-group>
                    <el-menu-item index="1-1">平台公告</el-menu-item>
                  </el-menu-item-group> -->

                </el-submenu>
                <el-submenu index="2">
                  <template slot="title">
                    <span @click="menuAboutus(2)">关于产品</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item index="2-1">产品介绍</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="2-2">账户介绍</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="2-3">产品细则</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="2-4">今日汇率</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-submenu index="3">
                  <template slot="title">
                    <span @click="menuAboutus(3)">平台下载</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item index="3-1">APP下载</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="3-2">MT4下载</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="3-3">MT5下载</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-submenu index="4">
                  <template slot="title">
                    <span @click="menuAboutus(4)">行情资讯</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item index="4-1">财经日历</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="4-2">热点新闻</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="4-3">市场快讯</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="4-4">专家评论</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="4-5">红狮课堂</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-menu-item index="5">
                  <span slot="title">数据中心</span>
                </el-menu-item>
                <el-submenu index="6">
                  <template slot="title">
                    <span @click="menuAboutus(6)">投资百科</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item index="6-1">知识百科</el-menu-item>
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="6-2">深度成交</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-menu-item index="7">
                  <span slot="title">常见问答</span>
                </el-menu-item>
                <el-menu-item index="8">
                  <span slot="title">用户中心</span>
                </el-menu-item>
                <el-menu-item index="9">
                  <span slot="title">联系客服</span>
                </el-menu-item>
              </el-menu>
            </el-col>
          </div>



        </div>
      </van-popup>
    </div>
    <!-- 悬浮弹框 -->
    <div class="chat-container" v-if="chatShow" :class="{ 'minimized': isMinimized }" ref="chatWindow"
      @mousedown="startDrag">
      <!-- 标题栏 -->
      <div class="chat-header" @dblclick="toggleMinimize">

        <span class="close-btn" @click="closeWindow">×</span>
      </div>
      <!-- 消息区域 -->
      <div class="messages-area" ref="messagesArea">
        <iframe ref="contentFrame" style="height: 100%;" :src="live800UrlUc"
          frameborder="0"></iframe>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Qrcode from '@/component/QrCode/index.vue'
import HumanService from '@/component/HumanService/index.vue'
import { handleMT5Trade } from '@/utils/tools'

export default {
  components: {
    Qrcode,
    HumanService,

  },
  props: {
    activeIndex: {
      type: String,
      default: '-1'
    }
  },
  data() {
    return {

      scroll: '',
      navBarFixed: false,
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      menuList: [
        {
          name: '关于我们', path: '/about', isLink: true, children: [
            { name: '公司简介', path: '/about', isLink: true },
            // { name: '平台公告', path: '/Notice', isLink: true }
          ]
        },
        {
          name: '关于产品', path: '/product', isLink: true, children: [
            { name: '产品介绍', path: '/product?key=1', isLink: true },
            { name: '账户介绍', path: '/product?key=2', isLink: true },
            { name: '产品细则', path: '/product?key=3', isLink: true },
            { name: '今日汇率', path: '/product?key=4', isLink: true },
          ]
        },
        { name: '立即交易', key: 'trader', isLink: false },
        {
          name: '平台下载', path: '/Appdownload', isLink: true, children: [
            { name: 'PC网页版', key: 'trader', isLink: false },
            { name: 'APP下载', path: '/Appdownload?key=1', isLink: true },
            { name: 'MT4下载', path: '/Appdownload?key=2', isLink: true },
            { name: 'MT5下载', path: '/Appdownload?key=3', isLink: true },
          ]
        },
        {
          name: '行情资讯', path: '/Market', isLink: true, children: [
            { name: '财经日历', path: '/Market?key=1', isLink: true },
            { name: '热点新闻', path: '/Market?key=2', isLink: true },
            { name: '市场快讯', path: '/Market?key=3', isLink: true },
            { name: '专家评论', path: '/Market?key=4', isLink: true },
            { name: '红狮课堂', key: 'live', isLink: false },
          ]
        },
        { name: '数据中心', path: '/Details', isLink: true },
        {
          name: '投资百科', path: '/Encyclopedia', isLink: true, children: [
            { name: '知识百科', path: '/Encyclopedia', isLink: true },
            { name: '深度成交', path: '/marketDepth', isLink: true },
          ]
        },
        { name: '常见问答', path: '/Faq', isLink: true },
        { name: '用户中心', key: 'userCenter', isLink: false },
        { name: '联系客服', key: 'customer', isLink: false },
      ],
      show: false,
      // 控制wap-menu菜单显示哪一个
      controlMenuClass: '',
      // 控制wap-menu菜单展开哪个
      defaultWapMenu: [],
      isActive: false,
      isDragging: false,
      dragStartPos: { x: 0, y: 0 },
      windowStartPos: { x: 0, y: 0 },
      isMinimized: false,
      newMessage: '',
      chatShow: false, // 控制悬浮框显示

    };
  },
  computed: {
    ...mapState('common', {
      androidMt4DownloadUrl: 'androidMt4DownloadUrl',
      androidDownloadUrl: 'androidDownloadUrl',
      iosMt4DownloadUrl: 'iosMt4DownloadUrl',
      iosMt5DownloadUrl: 'iosMt5DownloadUrl',
      live800UrlUc: 'live800UrlUc',

    })

  },
  methods: {
    // 拖拽相关方法
    startDrag(e) {
      if (this.isMinimized) return
      this.isDragging = true
      this.dragStartPos = {
        x: e.clientX - this.$refs.chatWindow.offsetLeft,
        y: e.clientY - this.$refs.chatWindow.offsetTop
      }
      this.windowStartPos = {
        x: this.$refs.chatWindow.offsetLeft,
        y: this.$refs.chatWindow.offsetTop
      }
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },
    onDrag(e) {
      if (!this.isDragging) return
      const x = e.clientX - this.dragStartPos.x
      const y = e.clientY - this.dragStartPos.y
      this.$refs.chatWindow.style.left = `${x}px`
      this.$refs.chatWindow.style.top = `${y}px`
    },
    stopDrag() {
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },



    // 辅助方法
    toggleMinimize() {
      this.isMinimized = !this.isMinimized
    },
    closeWindow() {
      this.$refs.chatWindow.style.display = 'none'
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesArea
        container.scrollTop = container.scrollHeight
      })
    },
    formatTime(timestamp) {
      return new Date(timestamp).toLocaleTimeString()
    },
    // 立即交易
    handleTrade() {
      handleMT5Trade()
    },
    // 开立账户
    btnClikc() {
      let domin = document.domain;
      window.open('https://' + domin + '/uc/signUp/real');

    },
    // pc端menu
    handleSelect(key) {
      console.log('3333333333', key)
      this.controlMenuClass = key;
      this.handleMenu(this.menuList[key])
    },
    handleMenu(item) {
      const { isLink, path, key } = item;
      if (isLink) {
        this.$router.push(path);

      } else {
        switch (key) {
          case 'trader':
            this.activeIndex = 2
            handleMT5Trade()
            this.show = false

            break;
          case 'userCenter':
            this.activeIndex = 8
            window.open('https://www.rlcproltd.net/uc/userCenter');
            this.show = false

            break;
          case 'customer':
            this.activeIndex = 9
            if(this.live800UrlUc.indexOf('ui/chat')> -1) {
            this.chatShow = !this.chatShow

            }else{
              window.open(this.live800UrlUc)

            }
            this.show = false

            break;
          case 'live':
            this.activeIndex = 4
            this.$router.push({
              name: "classRoom",
            });
            this.show = false

            break;
        }
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 600) { //判断滚动后高度超过400px,就显示
        // this.$refs.btn.style.display = 'block';
      } else {
        // this.$refs.btn.style.display = 'none'
      }
      if (this.scroll > 90) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    // 点击logo跳转到首页-web
    logoClick() {

      this.$router.push({
        name: "Index"
      });
    },
    // 点击logo跳转到首页-wap
    logoClickWap() {
      this.$router.push({
        name: "Index"
      });
    },
    // -----------------------------------------------------wap端-----------------------
    //  wap端menu
    menuAboutus(key) {
      this.controlMenuClass = key;
      this.handleMenu(this.menuList[key])
    },
    // 控制mune弹出层
    controlMenuShow() {
      this.show = true;
      // console.log(document.getElementsByClassName("van-icon")[0]);
    },
    // wap-el-menu打开
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    // wap-el-menu关闭
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 打开弹出层且动画结束后触发
    openPopup() {
      // this.$refs.navBarFixed.style.height = '100%'
      // document.getElementsByClassName("navBarWrap")[0].style.height = '100%';
    },
    // 点击关闭弹出层图片时触发
    closerPopup() {
      // document.getElementsByClassName("navBarWrap")[0].style.height = '';
      // this.$refs.navBarFixed.style.height = ''
    },

    // 点击一级菜单
    menuAboutus(key) {
      switch (key) {
        case 1:
          this.$router.push({
            name: "About"
          });
          this.show = false;

          break;
        case 2:
          this.$router.push({
            name: "Product"
          });
          this.show = false;

          break;
        case 3:
          this.$router.push({
            name: "Appdownload"
          });
          this.show = false;

          break;
        case 4:
          this.$router.push('/Market');
          this.show = false;

          break;
      }
    },
    handleSelects(key) {

      // this.getSessinKey(key);
      switch (key) {
        case '1':
          this.controlMenuClass = key;

          this.$router.push('/about');
          this.show = false;
          break;
        case '2':
          this.controlMenuClass = key;

          this.$router.push('/product')
          this.show = false;
          break;
        case '3':
          this.controlMenuClass = key;

          this.$router.push('/Appdownload');
          this.show = false;
          break;
        case '4':
          this.controlMenuClass = key;

          this.$router.push("/Market");
          this.show = false;
          break;
        case '5':
          this.controlMenuClass = key;

          this.$router.push('/Details');
          this.show = false;
          break;
        case '6':
          this.controlMenuClass = key;
          this.$router.push('/Encyclopedia');
          this.show = false
          break;
        case '7':
          this.controlMenuClass = key;
          this.$router.push('/Faq');
          this.show = false
          break;
        case '8':
          this.controlMenuClass = key;

          window.open('https://www.rlcproltd.net/uc/userCenter');

          this.show = false;
          break;
        case '9':
          this.controlMenuClass = key;
          const domin = document.domain;
          if (this.live800UrlUc.indexOf('ui/chat') > -1) {
            this.chatShow = !this.chatShow

          } else {
            window.open(this.live800UrlUc)

          }
          this.show = false
          break;
        
        // 移动端menu
        case '1-1':
          this.controlMenuClass = key;
          this.$router.push('/Notice');
          this.show = false;
          break;
        case '1-2':
          this.controlMenuClass = key;
          this.$router.push('/about');
          this.show = false;
          break;
        case '2-1':
          this.controlMenuClass = key;
          this.$router.push('/product?key=1');
          this.show = false;
          break;
        case '2-2':
          this.controlMenuClass = key;
          this.$router.push('/product?key=2');
          this.show = false;
          break;
        case '2-3':
          this.controlMenuClass = key;
          this.$router.push('/product?key=3');
          this.show = false;
          break;
        case '2-4':
          this.controlMenuClass = key;
          this.$router.push('/product?key=4');
          this.show = false;
          break;
        case '3-1':
          this.controlMenuClass = key;
          this.$router.push('/Appdownload?key=1');
          this.show = false;
          break;
        case '3-2':
          this.controlMenuClass = key;
          this.$router.push('/Appdownload?key=2');
          this.show = false;
          break;
        case '3-3':
          this.controlMenuClass = key;
          this.$router.push('/Appdownload?key=3');
          this.show = false;
          break;
        case '4-1':
          this.controlMenuClass = key;
          this.$router.push('/Market?key=1');
          this.show = false;
          break;
        case '4-2':
          this.controlMenuClass = key;
          this.$router.push('/Market?key=2');
          this.show = false;
          break;
        case '4-3':
          this.controlMenuClass = key;
          this.$router.push('/Market?key=3');
          this.show = false;
          break;
        case '4-4':
          this.controlMenuClass = key;
          this.$router.push('/Market?key=4');
          this.show = false;
          break;
        case '4-5':
          this.activeIndex = '5';
          this.controlMenuClass = key;
          this.$router.push({
            name: "classRoom",
          });
          this.show = false;
          break;
        case '6-1':
          this.controlMenuClass = key;
          this.$router.push('/Encyclopedia');
          this.show = false;
          break;
        case '6-2':
          this.controlMenuClass = key;
          this.$router.push('/marketDepth');
          this.show = false;
          break;

      }
    },

  },
  mounted() {
    this.scrollToBottom()

  }
}
</script>

<style lang="less" scoped>
.help-button {
  padding: 8px 16px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.header__layout {
  padding: 0 5%;
  margin: auto;
  background-color: #ffffff;

  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  .tologo {
    position: absolute;
    top: 10%;
    left: 12%;
    width: 130px;
    height: 60px;
    cursor: pointer;
  }

  .logo {
    height: 31px;
    cursor: pointer;

  }

  .backlogo {
    position: absolute;
    top: 10%;
    left: 2%;
    width: 240px;
    height: 45px;
    cursor: pointer;

  }

  .header-menu {

    &-item {
      position: relative;
      font-size: 1em;
      height: 80px;
      // color: #fff;
      color: #000;

      &:hover {
        .child-menu {
          display: flex;
        }
      }

      &:focus {
        outline: none;
      }

      .child-menu {
        position: absolute;
        width: 100%;
        background-color: #ffffff;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        top: 80px;
        left: 0px;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        display: none;

        p {
          color: #474747;
        }

        P:hover {
          color: #d42426;
        }
      }

      .active-line {
        position: absolute;
        bottom: 15px;
        width: 40px;
        height: 4px;
        background: #FA2314;
      }
    }
  }

  .flexs {
    display: flex;
    align-items: center;
  }

  .open {
    width: 120px;
    height: 40px;
    border-radius: 4px;
    background: #FA2314;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin-right: 20px;
  }

  .opens {

    background-size: 100% 100%;
  }

  .deal {
    border: 1px solid #0F0F11;
    // border: 1px solid #fff;
    width: 120px;
    height: 40px;
    border-radius: 4px;
    text-align: center;
    line-height: 40px;
    // color: #fff;
    color: #0F0F11;
  }

  .deals {
    border: 1px solid #fff;
    color: #fff;
  }
}

.heads_layout {
  display: flex;
  align-items: center;
  justify-content: center;
  // background: url(/subject/dressup/bg.png) no-repeat;
  background-size: 100% 100%;
  padding-left: 20%;

}

#box {
  .wapBox {
    display: none;
  }

  .wapTopBox {
    display: none;

  }
}

/deep/ .el-menu--horizontal {
  background-color: rgba(255, 255, 255, 0);
  // background-color: #ffffff;


}

/deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  // background-color: #ffffff;
  background-color: rgba(255, 255, 255, 0);
}

#header-img {
  width: 130px;
  height: auto;
  float: left;
  margin: 0 auto;
}

.header-logo {
  width: 130px;
  height: auto;
}

.header-important {
  float: left;
  margin-left: 6px;
  align-self: center;
}

/deep/ .el-menu--horizontal>.el-menu-item.is-active {
  color: #FA2314;  
  // color: #fff;
  border-bottom: 0px solid #ffffff;
}

/deep/ .el-menu-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

/deep/ .el-menu.el-menu--horizontal {
  // 去掉element-ui导航栏底部边框线
  border-bottom: none;
}

.navBarWrap {
  width: 100%;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 999;
  background-color: #ffffff;
  // transition: all .5s;
}

@media screen and (max-width: 1600px) {
  .header[data-v-005bfc5a] {
    max-width: 1310px;
  }

  #box .top .topBox[data-v-005bfc5a] {
    max-width: 1310px;
  }

  #box .top .topBox .tbCenter p:nth-child(3) ul[data-v-005bfc5a] {
    right: 0px;
  }
}

@media screen and (max-width: 500px) {
  #box {
    .header__layout {
      .logo {}
    }


    .header__layout {
      display: none;
    }

    .wapBox {
      display: block;
      width: 100%;

      .menuBox {
        /deep/ .el-menu--horizontal {
          background-color: #ffffff;
          display: flex;
          flex-direction: column;
        }

        .logoBox {
          height: 45px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          #header-img {
            width: 100px;
            height: auto;
          }
        }

        .el-menu-item {
          height: 56px;
          justify-items: flex-start;
          align-items: flex-start;
        }

        .header-menu {

          &-item {
            position: relative;
            font-size: 1em;
            height: 80px;

            &:hover {
              .child-menu {
                display: flex;
              }
            }

            &:focus {
              outline: none;
            }

            .child-menu {
              position: absolute;
              width: 100%;
              background-color: #ffffff;
              border-bottom-right-radius: 10px;
              border-bottom-left-radius: 10px;
              top: 80px;
              left: 0px;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;
              display: none;

              p {
                color: #474747;
              }

              P:hover {
                color: #d42426;
              }
            }

            .active-line {
              position: absolute;
              bottom: 15px;
              width: 40px;
              height: 4px;
              background: #FA2314;
            }
          }
        }

      }

      /deep/.van-popup__close-icon--top-right {
        top: 12px;
      }
    }

    .wapTopBox {
      display: block;
      width: 100%;
      // height: 45px;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 10px;
      position: fixed;
      background: #fff;
      // background: url(/subject/springCustom/wapheader.png) no-repeat;
      background-size: 100% 100%;
      top: 0;
      left: 0;
      z-index: 999;

      .tologo {
        position: absolute;
        top: 10%;
        left: 16%;
        width: 130px;
        height: 60px;
        cursor: pointer;

      }

      .img {
        width: 110px;
        height: auto;
      }

      .imgs {
        width: 22px;
        height: auto;
      }

      .menuImgs {
        // width: 22px;
        // top: 30%;
        // right: 20%;
        height: auto;
        position: absolute;
        width: 24px;
        top: 25%;
        left: 2%;
      }
    }

    .wapTopBoxs {
      background: url(/subject/dressup/wap/bg.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}

// -------------------------小屏幕适配-------------------
// -------------------150%--------------
@media screen and (min-width: 1264px) and (max-width: 1517px) {
  #box {
    .header__layout {
      padding: 0 5%;
      margin: auto;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      box-sizing: border-box;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;

      .logo {
        cursor: pointer;
      }

      .header-menu {

        &-item {
          position: relative;
          font-size: 0.2em;
          height: 80px;
          padding: 0 12px;

          &:hover {
            .child-menu {
              display: flex;
            }
          }

          &:focus {
            outline: none;
          }

          .child-menu {
            position: absolute;
            width: 100%;
            background-color: #ffffff;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
            top: 80px;
            left: 0px;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            display: none;

            p {
              color: #474747;
            }

            P:hover {
              color: #d42426;
            }
          }

          .active-line {
            position: absolute;
            bottom: 15px;
            width: 40px;
            height: 4px;
            background: #FA2314;
          }
        }
      }

      .flexs {
        display: flex;
        align-items: center;
      }

      .open {
        width: 70px;
        height: 40px;
        border-radius: 4px;
        background: #FA2314;
        color: #fff;
        text-align: center;
        line-height: 40px;
        margin-right: 20px;
        font-size: 12px;
      }

      .opens {
        background-size: 100% 100%;
      }

      .deal {
        border: 1px solid #0F0F11;
        width: 70px;
        height: 40px;
        border-radius: 4px;
        text-align: center;
        line-height: 40px;
        color: #0F0F11;
        font-size: 12px;
      }

      .deals {
        border: 1px solid #fff;
        color: #fff;
      }
    }

    .heads_layout {
      padding-left: 19%;
    }
  }
}

// ---------------125%------------------
@media screen and (min-width: 1517px) and (max-width: 1724px) {
  #box {
    .header__layout {
      padding: 0 5%;
      margin: auto;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      box-sizing: border-box;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;

      .logo {
        cursor: pointer;
      }

      .header-menu {

        &-item {
          position: relative;
          font-size: 14px;
          height: 80px;

          &:hover {
            .child-menu {
              display: flex;
            }
          }

          &:focus {
            outline: none;
          }

          .child-menu {
            position: absolute;
            width: 100%;
            background-color: #ffffff;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
            top: 80px;
            left: 0px;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            display: none;

            p {
              color: #474747;
            }

            P:hover {
              color: #d42426;
            }
          }

          .active-line {
            position: absolute;
            bottom: 15px;
            width: 40px;
            height: 4px;
            background: #FA2314;
          }
        }
      }

      .flexs {
        display: flex;
        align-items: center;
      }

      .open {
        width: 120px;
        height: 40px;
        border-radius: 4px;
        background: #FA2314;
        color: #fff;
        text-align: center;
        line-height: 40px;
        margin-right: 20px;
        font-size: 14px;
      }

      .opens {
        background-size: 100% 100%;
      }

      .deal {
        // border: 1px solid #0F0F11;
        width: 120px;
        height: 40px;
        border-radius: 4px;
        text-align: center;
        line-height: 40px;
        // color: #0F0F11;
        border: 1px solid #fff;
        color: #fff;
        font-size: 14px;
      }

      .deals {
        border: 1px solid #fff;
        color: #fff;
        font-size: 14px;
      }
    }

    .heads_layout {
      padding-left: 19%;
    }
  }
}

.chat-container {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 350px;
  height: 500px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  transition: all 0.3s ease;
}

.minimized {
  height: 40px;
  overflow: hidden;
}

.chat-header {
  padding: 10px 15px;
  background: #f0f0f0;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: move;
}

.close-btn {
  font-size: 20px;
  cursor: pointer;

}

.messages-area {
  flex: 1;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.message {
  max-width: 70%;
  padding: 8px 12px;
  border-radius: 18px;
}

.user-message {
  align-self: flex-end;
  background: #0084ff;
  color: white;
}

.bot-message {
  align-self: flex-start;
  background: #f0f0f0;
  color: #333;
}

.timestamp {
  font-size: 10px;
  margin-top: 4px;
  opacity: 0.7;
}

.input-area {
  padding: 15px;
  border-top: 1px solid #eee;
  display: flex;
}

input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 20px;
  margin-right: 10px;
}

button {
  padding: 8px 16px;
  background: #0084ff;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}
</style>